<template>
  <b-card-group :title="vector" class="vector-widget">

    <div v-if="isElectricEnergy"
         class="w-100 h5 text-right mb-2 pr-2">
      <font-awesome-icon
        class="lock-link"
        :icon="lockIcon"
        @click="toggleLocking"/>
    </div>

    <b-container fluid class="p-0">
      <b-row
        class="dashboard-top-widgets"
        v-observe-visibility="(isVisible, entry) => visibilityChanged(
          isVisible, entry, 'top-widgets')">
        <b-col cols="4" class="row__same-height"
               v-if="visibility['top-widgets']">
          <Consumption
            :vector="vector"/>
        </b-col>
        <b-col cols="3" class="row__same-height"
               v-if="visibility['top-widgets']">
          <Power v-if="isElectricEnergy"/>
          <Weather v-else/>
        </b-col>
        <b-col cols="5" class="row__same-height"
               v-if="visibility['top-widgets']">
          <IPG :vector="vector"/>
        </b-col>
      </b-row>

      <div
        v-show="isVisibleConsumptionGraph || isElectricEnergy"
        v-observe-visibility="(isVisible, entry) => visibilityChanged(
          isVisible, entry, 'ConsumptionAndSlots')"
        class="dashboard-consumption-and-slots"
      >
        <ConsumptionAndSlots
          v-if="visibility['ConsumptionAndSlots']"
          @hide="hideConsumptionGraph"
          :vector="vector" />
      </div>

      <b-row
        v-observe-visibility="(isVisible, entry) => visibilityChanged(
          isVisible, entry, 'ConsumptionMonthly')"
        class="dashboard-consumption-monthly"
      >
        <b-col
          v-if="visibility['ConsumptionMonthly']"
        >
          <ConsumptionMonthly :vector="vector"/>
        </b-col>
      </b-row>
    </b-container>
  </b-card-group>
</template>

<script>
import Consumption from './widgets/Consumption';
import Power from './widgets/Power';
import IPG from './widgets/IPG';
import ConsumptionAndSlots from './widgets/ConsumptionAndSlots';
import ConsumptionMonthly from './widgets/ConsumptionMonthly';
import Weather from "./widgets/Weather";

const ELECTRIC_ENERGY = 'EE';

export default {
  components: {
    Consumption,
    Power,
    IPG,
    ConsumptionAndSlots,
    ConsumptionMonthly,
    Weather,
  },

  props: {
    vector: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      visibility: {},
      isVisibleConsumptionGraph: true,
    };
  },

  computed: {
    isElectricEnergy() {
      return this.vector === ELECTRIC_ENERGY;
    },

    lockIcon() {
      return this.isLockWidgets ? 'lock' : 'unlock';
    },

    isLockWidgets: {
      get() {
        return this.$store.state.dashboard.isLocked;
      },
      set(isLocked) {
        this.$store.dispatch('dashboard/setIsLocked', isLocked);
      }
    },
  },

  methods: {
    hideConsumptionGraph(){
      this.isVisibleConsumptionGraph = false;
    },

    visibilityChanged(isVisible, entry, key) {
      if (isVisible) {
        this.$set(this.visibility, key, isVisible);
      }
    },

    toggleLocking() {
      this.isLockWidgets = !this.isLockWidgets;
    }
  }
}
</script>

<style>
.row > .row__same-height {
  display: flex;
  flex-direction: row; 
}
.col-3 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
  padding-right: 0px !important;
}

.col-4 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.333333%;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
  padding-right: 10px !important;
}
.col-5 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.666667%;
  flex: 0 0 41.666667%;
  max-width: 41.666667%;
  padding-left: 10px !important;
}

.row > .row__same-height > .card {
  width: 100%;
}

.vector-widget .card-title {
  padding-bottom: 15px;
}

.lock-link {
  cursor: pointer;
}

/* Hide unused buttons from download toolbar of chart */
.vector-widget .exportSVG,
.vector-widget .exportCSV {
  display: none;
}

.dashboard-top-widgets {
  min-height: 360px;
}
.dashboard-consumption-monthly {
  min-height: 470px;
}
.dashboard-consumption-and-slots {
  min-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/VectorWidgets.vue